export const ROUTE_COLORS = [
  '#38bdf8', // primary — cyan
  '#f59e0b', // amber
  '#ec4899', // pink
  '#22c55e', // green
  '#a78bfa', // violet (extras, in case of >4)
];

export function routeColor(i: number): string {
  return ROUTE_COLORS[i % ROUTE_COLORS.length];
}

